/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReservationSummary
 */
export interface ReservationSummary {
    /**
     * 
     * @type {string}
     * @memberof ReservationSummary
     */
    bookingId: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationSummary
     */
    gondolaBookingId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationSummary
     */
    chainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationSummary
     */
    propertyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationSummary
     */
    checkIn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationSummary
     */
    checkOut?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationSummary
     */
    guestLastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationSummary
     */
    createdAt?: string | null;
    /**
     * Minutes since the booking was created (how long it's been awaiting fulfillment).
     * @type {number}
     * @memberof ReservationSummary
     */
    ageMinutes?: number | null;
    /**
     * Booking status (e.g. processed / unprocessed / cancelled). Populated for the operator's booking history.
     * @type {string}
     * @memberof ReservationSummary
     */
    status?: string | null;
    /**
     * The supplier confirmation number, when the booking has been completed.
     * @type {string}
     * @memberof ReservationSummary
     */
    confirmationNumber?: string | null;
}

/**
 * Check if a given object implements the ReservationSummary interface.
 */
export function instanceOfReservationSummary(value: object): value is ReservationSummary {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function ReservationSummaryFromJSON(json: any): ReservationSummary {
    return ReservationSummaryFromJSONTyped(json, false);
}

export function ReservationSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReservationSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'chainName': json['chain_name'] == null ? undefined : json['chain_name'],
        'propertyName': json['property_name'] == null ? undefined : json['property_name'],
        'checkIn': json['check_in'] == null ? undefined : json['check_in'],
        'checkOut': json['check_out'] == null ? undefined : json['check_out'],
        'guestLastName': json['guest_last_name'] == null ? undefined : json['guest_last_name'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'ageMinutes': json['age_minutes'] == null ? undefined : json['age_minutes'],
        'status': json['status'] == null ? undefined : json['status'],
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
    };
}

export function ReservationSummaryToJSON(json: any): ReservationSummary {
    return ReservationSummaryToJSONTyped(json, false);
}

export function ReservationSummaryToJSONTyped(value?: ReservationSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'gondola_booking_id': value['gondolaBookingId'],
        'chain_name': value['chainName'],
        'property_name': value['propertyName'],
        'check_in': value['checkIn'],
        'check_out': value['checkOut'],
        'guest_last_name': value['guestLastName'],
        'created_at': value['createdAt'],
        'age_minutes': value['ageMinutes'],
        'status': value['status'],
        'confirmation_number': value['confirmationNumber'],
    };
}

